import React, { useState,useEffect } from 'react';
import { useNavigate, useParams,useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './nicepage.css';
import './Dashboard.css';
import Header from './Header';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import printalBg from '../images/printalBg.jpg'
const ShowIclinicEvent = () => {
    const [loading,setLoading] = useState(false);
    const navigate = useNavigate();
    const { eventId } = useParams();
    const location = useLocation();
    // console.log("users_inclinic = ", sessionStorage.getItem('clientId'))
    // console.log("location.state.clientId_inclinic",location.state.clientId)
    const clientId = location.state?.clientId || sessionStorage.getItem('clientId');
    const role = location.state?.role || sessionStorage.getItem('role') || '';
    const pmId = location.state?.pmId || sessionStorage.getItem('pmId') || '';
    const compId = location.state?.compId || '';
    const pmName = location.state?.pmName || '';
    const companyName = location.state?.companyName || '';
    const [selectedIclinic, setSelectedIclinic] = useState('');
    const [selectedIclinicDisplays, setselectedIclinicDisplays] = useState('');
    const [printingData,setPrintingData] = useState([]);
    const [Branding,setBranding] = useState([]);
    useEffect(()=>{
        setSelectedIclinic(location.state?.selectedIclinic || '');
        setselectedIclinicDisplays(location.state?.selectedIclinicDisplays || '');
        setPrintingData(location.state?.printingData || []);
        setBranding(location.state?.Branding || '');
    },[location.state])
    // Redirect to Estimate exhibition page when client click on exhibition button
    const handleExhibition = (e) => {
        e.preventDefault()
        console.log("handle = ",clientId);
        navigate(`/dashboard/showexhibitionevent/${eventId}`,
        {
            state : {
                        clientId: clientId,
                        role: role,
                        pmId: pmId,
                        compId : compId,
                        pmName : pmName,
                        companyName : companyName,
                    }
        });
    }
    // Redirect to Estimate event page when client click on EVENT button
     const handleEvent = (e) => {
        e.preventDefault();
        navigate(`/dashboard/showestimateseevent/${eventId}`,{
            state : {
                clientId: clientId,
                role: role,
                pmId: pmId,
                compId : compId,
                pmName : pmName,
                companyName : companyName,
            }
        });
    };

    const handleIclinicChange = (e) => {
        const value = e.target.value.trim();
        console.log("value = ",value);
        if(value.length > 0){
            setSelectedIclinic(value);
        }
        else{
            setSelectedIclinic('');
            setselectedIclinicDisplays('');
            setPrintingData([]); // Reset Printing Data value selection when iclinic change
             // Reset Display Value selection when Iclinic changes
        }
         
    };
    const fetchPrintingData = async(iclinicData) => {
        setLoading(true);
        try{
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/get_inclinic_printing`,{
                inclinic_data : selectedIclinic,
                inclinic_printing : iclinicData
            });  
            console.log("response = ",response);
            if(response.status == 200){
                setPrintingData(response.data.data || []); 
            }
            else{
                setPrintingData([]); 
            }
        }
        catch(err){
            setPrintingData([]);
        }
        finally{
            setLoading(false);
        }
    }
    const handleIclinicDisplays = (e) => {
        const data = e.target.value;
        setselectedIclinicDisplays(data);
        if(data.length > 0){
            fetchPrintingData(data);
        }
        else{
            setPrintingData([]);
        }
    };
    const handlePrintingData = (e) => {
        e.preventDefault();
        setBranding(e.target.value);
    }
    const handleNext = (e) => {
        console.log("clientId = ",clientId);
        e.preventDefault();
        navigate(`/dashboard/nexticlinicevent/${eventId}`,
        {
            state:
            {
                estimateType: 'INCLININC',
                selectedIclinic : selectedIclinic,
                selectedIclinicDisplays : selectedIclinicDisplays,
                printingData:printingData,
                Branding : Branding,
                role:role,
                pmId:pmId,
                clientId: clientId,
                compId : compId,
                pmName : pmName,
                companyName : companyName
            }
        });
    }
    return (
        <>
            <div className="u-body u-xl-mode" data-lang="en">
               <Header imagTag = '../../' role = {role} active = {{estimates:1}}/>
            </div>
            <div className="bg-image-container">
          <img src={printalBg} alt="event background" className="img-fluid" />
          <div className="title_name">
            <p
              style={{
                fontSize: "5rem",
                lineHeight: 1,
                transform: "translate(0%, -22%)",
                textAlign: "left",
              }}
            >
              BRANDING <br/>& PRINTING
            </p>
            <div
              className="d-flex align-items-center justify-content-between w-50"
              style={{ gap: "25px" }}
            >
              <Button
                className="addNewBtn"
                size="lg"
                onClick={() => navigate("/dashboard")}
              >
                Event
              </Button>
              <Button
                className="addNewBtn"
                size="lg"
                // onClick={handleShowEventModal}
                onClick={() => {
                  const eventId = sessionStorage.getItem("eventid");
                  if (eventId) {
                    navigate(`/dashboard/showexhibitionevent/${eventId}`);
                  } else alert("create an event first or select an existing even from the above dropdown..");
                }}
              >
                Conference/Exibition
              </Button>
              <Button
                 className={
                    window.location.pathname.includes(
                      "/dashboard/showiclinicevent"
                    )
                      ? "active_btn"
                      : "addNewBtn"
                  }
                size="lg"
                // onClick={handleShowEventModal}
                onClick={() => {
                  const eventId = sessionStorage.getItem("eventid");
                  if (eventId) {
                    navigate(`/dashboard/showiclinicevent/${eventId}`);
                  } else alert("create an event first or select an existing even from the above dropdown..");
                }}
              >
                Printle Solution
              </Button>
            </div>
            {/* <p className='company_name'><span>{companyName}</span></p> */}
            {/* <div className="container mt-2 mb-2 d-flex align-items-center justify-content-center">
                            <SearchBar searchTerm={searchTerm} onSearchChange={handleSearchChange}/>
                        </div>
                        <div className='d-flex align-items-center'>
                            {role == 1 && <div className = 'col-12 col-lg-2 col-md-2 mt-2 mb-2'><Button className="addNewBtn" size="lg" onClick={handleShowEventModal}>
                                Add New Event
                            </Button></div> }
                        </div> */}
          </div>
        </div>
            <div className="container">
                {/* <div className="row justify-content-center">
                    <div className="col-2">
                        <img
                            src="../../images/logo1.png"
                            alt="Logo"
                            className="img-fluid"
                            style={{ maxHeight: '75px' }}
                        />
                    </div>
                </div> */}
                <div className="card mt-4 border-0">
                    <div className="card-body">
                        {/* <div className="row justify-content-center">
                            <div className="col-md-6 ms-4">
                                <a className="estimateButtonInActive" onClick={handleEvent}>Event</a>
                                <a className="estimateButtonInActive" onClick = {handleExhibition}>Conference/Exhibition</a>
                                <a className="estimateButtonActive">Printle Solution</a>
                            </div>
                        </div> */}
                        <h6 className="mt-5"><b>Select Branding & Marketing / Branding & Printing</b></h6>
                        <select className="form-select" onChange={handleIclinicChange} value = {selectedIclinic}>
                            <option value="">Select</option>
                            <option value="In-clinic Branding & Print Products">In-clinic Branding & Print Products</option>
                            {/* <option value="Merchandising">Merchandising</option> */}
                        </select>
                        {selectedIclinic.length > 0 && (
                            <div className="mt-4">
                            <h6><b>Select In-clinic Displays</b></h6>
                            <select className="form-select" onChange={handleIclinicDisplays} value={selectedIclinicDisplays}>
                                {selectedIclinic === 'Merchandising' ? (
                                    <>
                                        <option value="">Select</option>
                                        <option value="Corporate gifting">Corporate gifting</option>
                                        <option value="Stationary">Stationary</option>
                                    </>
                                ) : (
                                    <>
                                        <option value="">Select</option>
                                        <option value="In-clinic Displays">In-clinic Displays</option>
                                        <option value="Display stands">Display stands</option>
                                        <option value="Commercial printing">Commercial printing</option>
                                        <option value="Short run digital printing">Short run digital printing</option>
                                        <option value="Large format digital printing">Large format digital printing</option>
                                        <option value="Corporate gifting">Corporate Gifting</option>
                                        <option value="Collaterals">Collaterals</option>
                                        <option value="Outdoor Branding">Outdoor Branding</option>
                                    </>
                                )}
                            </select>
                          

                        </div>
                        )}
                        {loading && <div>Loading...</div>}
                        {
                            printingData.length > 0 && (
                                <div className="mt-4">
                                    <h6><b>Select Printing Data</b></h6>
                                    <select className="form-select" value={Branding} onChange={handlePrintingData}>
                                        <option value=''>Select Printing Data</option>
                                        {printingData.map((item, index) => (
                                            <option key={index} value={item.Branding}>{item.Branding}</option>
                                        ))}
                                    </select>
                                </div>
                            )
                        }
                    </div>
                    {Branding.length > 0 && (
                             <p>
                                <a className="estimateButtonInActive" onClick={(e) => {handleNext(e)}}>Next  --&gt;</a>
                            </p>
                    )}
                </div>
            </div>
        </>
    )
}
export default ShowIclinicEvent;